"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureServiceStub = void 0;
const faker_1 = __importDefault(require("faker"));
class FeatureServiceStub {
    async isGenerallyAvailable(featureName) {
        return { status: true, message: featureName, payload: { isEnabled: faker_1.default.random.boolean() } };
    }
}
exports.FeatureServiceStub = FeatureServiceStub;
//# sourceMappingURL=FeatureServiceStub.js.map